'use client';
import React, { useEffect, useState } from 'react';

const ELEMENTS = [
  { id: 'anim-wood', label: '木', color: '#7A9E7E', delay: 0 },
  { id: 'anim-fire', label: '火', color: '#C47B5A', delay: 0.4 },
  { id: 'anim-earth', label: '土', color: '#C4A96B', delay: 0.8 },
  { id: 'anim-metal', label: '金', color: '#A8ADB4', delay: 1.2 },
  { id: 'anim-water', label: '水', color: '#4A6B8A', delay: 1.6 },
];

const MESSAGES = [
  '正在解析出生時柱…',
  '計算五行能量比例…',
  '提取空間色彩傾向…',
  '生成你的居家色彩方案…',
];

export default function AnalyzingOverlay() {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % MESSAGES?.length);
    }, 700);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/95 backdrop-blur-sm">
      {/* Five element orbs */}
      <div className="relative w-48 h-48 mb-10">
        {ELEMENTS?.map((el, i) => {
          const angle = (i / ELEMENTS?.length) * 2 * Math.PI - Math.PI / 2;
          const r = 72;
          const x = 96 + r * Math.cos(angle);
          const y = 96 + r * Math.sin(angle);
          return (
            <div
              key={el?.id}
              className="absolute w-10 h-10 rounded-full analyzing-pulse flex items-center justify-center"
              style={{
                left: x - 20,
                top: y - 20,
                backgroundColor: el?.color,
                animationDelay: `${el?.delay}s`,
                opacity: 0.85,
              }}
            >
              <span className="text-white text-xs font-semibold">{el?.label}</span>
            </div>
          );
        })}

        {/* Center circle */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="w-14 h-14 rounded-full border-2 analyzing-pulse"
            style={{
              borderColor: 'var(--accent)',
              backgroundColor: 'var(--accent)',
              opacity: 0.15,
              animationDelay: '0.2s',
            }}
          />
        </div>

        {/* Connecting lines via SVG */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 192 192">
          {ELEMENTS?.map((el, i) => {
            const angle = (i / ELEMENTS?.length) * 2 * Math.PI - Math.PI / 2;
            const r = 72;
            const x = 96 + r * Math.cos(angle);
            const y = 96 + r * Math.sin(angle);
            return (
              <line
                key={`line-${el?.id}`}
                x1="96"
                y1="96"
                x2={x}
                y2={y}
                stroke={el?.color}
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })}
        </svg>
      </div>

      {/* Text */}
      <p className="text-sm font-medium text-foreground mb-2 transition-all duration-300">
        {MESSAGES?.[msgIndex]}
      </p>
      <p className="text-xs text-muted-foreground">
        正在分析你的五行比例與空間色彩……
      </p>
    </div>
  );
}